import { _ as _ListCache } from './_ListCache.mjs';

var ListCache = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

export { _stackClear as _ };
